(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/draw.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/draw.js');

'use strict';

const drawsApi = svs.numbergames.draws.drawsApi;
const productMapping = svs.numbergames.productMapping;
const calcLastDrawDate = (drawCount, firstDrawDate, daysBetweenDraws) => {
  const date = new Date(firstDrawDate);
  date.setDate(date.getDate() + (drawCount - 1) * daysBetweenDraws);
  return date;
};
class Draw {
  constructor(_ref) {
    let {
      productDrawId,
      daysBetweenDraws = 7
    } = _ref;
    this._productDrawId = productMapping.getProductDrawId(productDrawId);
    this.daysBetweenDraws = daysBetweenDraws;
  }
  get productItsId() {
    return productMapping.getProductItsId(this._productDrawId);
  }
  get product() {
    return this._productDrawId;
  }
  get isOpen() {
    return true;
  }
  isProductOpen() {
    return this.isOpen;
  }
  get openTime() {
    return drawsApi.regOpenTime(this._productDrawId);
  }
  get drawNumber() {
    return drawsApi.drawNumber(this._productDrawId);
  }
  get closeTime() {
    return drawsApi.regCloseTime(this._productDrawId);
  }
  get nextOpenTime() {
    return drawsApi.nextRegOpenTime(this._productDrawId);
  }
  get firstDrawDate() {
    return this.closeTime;
  }
  get wasOpenedToday() {
    return drawsApi.wasOpenedToday(this._productDrawId);
  }
  get isJokerOpen() {
    return this.isOpen && drawsApi.isJokerDrawOpen(this._productDrawId);
  }
  get jokerCloseTime() {
    return drawsApi.jokerRegCloseTime(this._productDrawId);
  }
  get jokerDrawNumber() {
    return drawsApi.jokerDrawNumber(this._productDrawId);
  }
  drawNumbers() {
    return [{
      productItsId: this.productItsId,
      drawNumber: this.drawNumber
    }];
  }
  firstAndLastDrawDates(_ref2) {
    let {
      drawCount
    } = _ref2;
    switch (drawCount) {
      case 'subscription':
        return {
          weekday: productMapping.getDay(this.product)
        };
      case '1':
        return {
          first: this.firstDrawDate
        };
      default:
        return {
          first: this.firstDrawDate,
          last: calcLastDrawDate(drawCount, this.firstDrawDate, this.daysBetweenDraws)
        };
    }
  }
}
svs.numbergames.draws.Draw = Draw;

 })(window);